import apiLambdaInsumo from "./apiLambdaInsumo"

function tratamentoResponse(response, chamada) {
    if (response.data.codErro > 0)
        return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
    else if (typeof response.data == "string" && response.data != "")
        return {
            retornoErro: 1,
            mensagem: chamada + " - Erro inesperado, entre em contato com os reponsáveis.",
        }
    else return response.data
}

const ErroRequisicao = data => {
    try {

        if (data.message === "Network Error") {
            return "Verifique sua conexão!"
        }

        if (data.request && data.request.responseText) {
            const resposta = JSON.parse(data.request.responseText)
            return resposta.mensagem || "Erro desconhecido!"
        }

        return "Erro inesperado na requisição!"
    } catch (error) {
        // RegistrarLogErro(error, "ErroRequisicao", data)
        return "Erro ao tratar requisição!"
    }
}

export const buscarFihcasTecnicas = async (idEstabelecimento, autorizacao) => {
    const url = `/fichaTecnica/buscar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaInsumo.get(url, { headers: headers })
        return tratamentoResponse(response, "buscarFihcasTecnicas")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
    }
}

export const buscarFichaTecnicaProduto = async (idEstabelecimento, idProduto, autorizacao) => {
    const url = `/fichaTecnica/buscar/${idEstabelecimento}/produto/${idProduto}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaInsumo.get(url, { headers: headers })

        return tratamentoResponse(response, "Inusumo")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const buscarFichaTecnicaOpcao = async (idEstabelecimento, idOpcao, autorizacao) => {
    const url = `/fichaTecnica/buscar/${idEstabelecimento}/opcao/${idOpcao}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaInsumo.get(url, { headers: headers })

        return tratamentoResponse(response, "Inusumo")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const salvarFichaTecnica = async (idEstabelecimento, data, autorizacao) => {
    const url = `/fichaTecnica/cadastrar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaInsumo.post(url, data, { headers: headers })

        return tratamentoResponse(response, "Inusumo")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const atualizarFichaTecnica = async (idEstabelecimento, ftiId, data, autorizacao) => {
    const url = `/fichaTecnica/atualizar/${idEstabelecimento}/${ftiId}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaInsumo.put(url, data, { headers: headers })

        return tratamentoResponse(response, "Inusumo")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const deletarFichaTecnica = async (idEstabelecimento, ftiId, autorizacao) => {
    const url = `/fichaTecnica/deletar/${idEstabelecimento}/${ftiId}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaInsumo.delete(url, { headers: headers })

        return tratamentoResponse(response, "Inusumo")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const vinculosFichaTecnica = async (idEstabelecimento, data, autorizacao) => {
    const url = `/fichaTecnica/vinculos/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaInsumo.post(url, data, { headers: headers })

        return tratamentoResponse(response, "Inusumo")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}
